import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { canonServices } from '@app/services/suite-shell.logic';
import { SuiteShellService } from '@app/services/suite-shell.service';

/** La cara clásica se queda en /services. La suite, en /flows/contratos. */
@Injectable({ providedIn: 'root' })
export class ServicesCaraGuard {
  constructor(
    private shell: SuiteShellService,
    private router: Router,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const destino = canonServices(this.shell.cara, state.url);
    return destino ? this.router.parseUrl(destino) : true;
  }
}
